import Scanner from './Intro'

export default Scanner
